import type { Nullable } from '../typescript/nullable';

export const EDGE_TYPE_NAME_MAX_LENGTH = 100;

export interface EdgeTypeInterface {
	id: string;
	name: string;
	type: Nullable<EdgeTypeEnum>;
	description: Nullable<string>;
	color: Nullable<string>;
	weight: number;
	permissions: EdgeTypesPermissions[];
	createdAt: string;
	updatedAt: string;
}
export enum EdgeTypeEnum {
	/**
	 * Default edge type for link between two nodes
	 */
	LINKED = 'LINKED',
	/**
	 * Edge type for reference to from note
	 */
	NOTE_REFERENCE = 'NOTE_REFERENCE',
}

export enum EdgeTypesPermissions {
	/**
	 * The user can delete the edge from the user
	 */
	DELETE_FROM_USER = 'DELETE_FROM_USER',
	/**
	 * The user can delete the edge from two nodes
	 */
	DELETE_FROM_GRAPH = 'DELETE_FROM_GRAPH',
	/**
	 * The user can update the edge type properties
	 */
	UPDATE = 'UPDATE',
}
